/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default [
  // {
  //   url: "/apps/email",
  //   name: "Email",
  //   slug: "email",
  //   icon: "MailIcon",
  //   i18n: "Email",
  // },
  {
    url: null,
    name: 'Dashboard',
    icon: 'HomeIcon',
    i18n: 'Dashboard',
    items: [
      {
        url: '/dashboard/ecommerce',
        name: 'eCommerce',
        slug: 'dashboard-ecommerce',
        i18n: 'eCommerce'
      }
    ]
  },
  {
    header: 'Conferences',
    icon: 'CalendarIcon',
    i18n: 'Conferences',
    items: [
      {
        url: '/apps/conferences',
        name: 'Conferences',
        slug: 'conferences',
        icon: 'CalendarIcon',
        i18n: 'Conferences'
      },
      {
        url: '/apps/email',
        name: 'Todo',
        slug: 'email',
        icon: 'MailIcon',
        i18n: 'Todo'
      },
      {
        url: '/apps/owners',
        name: 'Owners',
        slug: 'owners',
        icon: 'UserIcon',
        i18n: 'Owner'
      }
    ]
  },
  {
    header: 'Users',
    icon: 'UserIcon',
    i18n: 'Users',
    items: [
      {
        url: '/apps/users',
        name: 'Users',
        slug: 'user',
        icon: 'UserIcon',
        i18n: 'Users'
      },
      {
        url: '/apps/messages',
        name: 'Message',
        slug: 'message',
        icon: 'MailIcon',
        i18n: 'Message'
      }
    ]
  }
]
